module.exports = __webpack_public_path__ + "img/hh-tequila.e90f915d.jpeg";